import { TImageField, TLinkField, TStringField } from '../../../types/sitecore.types';
import { THeadingTag } from '../../../types/types';
import { getFollowingHTag } from '../../../utils/seo.utils';
import {
  TLatestNewsCardItemProps,
  TLatestNewsContext,
  TLatestNewsParams,
  TLatestNewsProps,
  TLatestNewsPropsFields,
  TLatestNewsPropsItemData,
} from '../types/latestNews.types';

export class LatestNewsModel {
  private readonly fields?: TLatestNewsPropsFields;
  private readonly itemData?: TLatestNewsPropsItemData;
  private readonly params?: TLatestNewsParams | null;
  private readonly context?: TLatestNewsContext;

  constructor(props: TLatestNewsProps) {
    this.fields = props?.fields || null;
    this.itemData = props?.fields?.itemData;
    this.params = props?.params || null;
    this.context = props?.sitecoreContext as TLatestNewsContext;
  }

  get title(): TStringField | undefined {
    return this.itemData?.fields?.title;
  }

  get eyebrow(): TStringField | undefined {
    return this.itemData?.fields?.eyebrow;
  }

  get baseUrl(): string {
    return this.itemData?.contextItemUrl || '';
  }

  get defaultCardImage(): TImageField | undefined {
    return {
      value: {
        src: this.context?.defaultBackgroundImageParameters?.desktopImageData?.latestNews,
      },
    };
  }

  get link(): TLinkField | undefined {
    return {
      value: {
        href: this.fields?.itemData?.fields?.newsMainPageLink?.value || '',
      },
    };
  }

  get headingTag(): THeadingTag {
    return (this.params?.headingTag?.toLowerCase() as THeadingTag) || 'h2';
  }

  get cardHeadingTitleTag(): THeadingTag {
    return getFollowingHTag(this.headingTag);
  }

  get items(): TLatestNewsCardItemProps[] {
    return this.fields?.apiData?.items || [];
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }
}
